var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedinIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7066 0H14.6411C6.71631 0 0.291992 6.4262 0.291992 14.3533V14.4188C0.291992 22.346 6.71631 28.7722 14.6411 28.7722H14.7066C22.6314 28.7722 29.0557 22.346 29.0557 14.4188V14.3533C29.0557 6.4262 22.6314 0 14.7066 0Z",
    fill: "#040742"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.1523 9.56297C6.77339 9.21116 6.58496 8.7757 6.58496 8.25757C6.58496 7.73945 6.7744 7.28482 7.1523 6.93201C7.53121 6.58021 8.01895 6.40381 8.61654 6.40381C9.21412 6.40381 9.68273 6.58021 10.0606 6.93201C10.4395 7.28382 10.628 7.72634 10.628 8.25757C10.628 8.78881 10.4385 9.21116 10.0606 9.56297C9.68172 9.91477 9.20102 10.0912 8.61654 10.0912C8.03205 10.0912 7.53121 9.91477 7.1523 9.56297ZM10.3095 11.581V22.3669H6.90239V11.581H10.3095Z",
    fill: "#FEFFFC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6517 12.6466C22.3944 13.4531 22.7652 14.5599 22.7652 15.9691V22.1766H19.5294V16.4066C19.5294 15.6959 19.345 15.1435 18.9772 14.7504C18.6093 14.3573 18.1135 14.1597 17.4928 14.1597C16.872 14.1597 16.3762 14.3563 16.0084 14.7504C15.6405 15.1435 15.4561 15.6959 15.4561 16.4066V22.1766H12.2012V11.5509H15.4561V12.9601C15.7857 12.4904 16.2301 12.1195 16.7884 11.8463C17.3467 11.5731 17.9745 11.437 18.6728 11.437C19.9164 11.437 20.91 11.8402 21.6517 12.6456V12.6466Z",
    fill: "#FEFFFC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin-icon.fea1832ef763b3b60e82b60a93b34cb2.svg";
export { ForwardRef as ReactComponent };